import { useTranslation } from 'react-i18next'
import ResponsiveShell from '../layout/ResponsiveShell'
import { useAuthStore } from '../../store/authStore'

export default function NoBranchAccessScreen() {
  const { t } = useTranslation()
  const branchError = useAuthStore((s) => s.branchError)

  return (
    <ResponsiveShell title={t('branchGate.noBranchTitle')}>
      <div className="min-h-[calc(100vh-120px)] flex items-center justify-center px-4 py-6">
        <div className="w-full max-w-lg rounded-2xl border border-zinc-200 bg-white p-6 shadow-sm">
          <h1 className="text-lg font-semibold text-zinc-900">
            {t('branchGate.noBranchTitle')}
          </h1>
          <p className="mt-2 text-sm text-zinc-600">
            {t('branchGate.noBranchDescription')}
          </p>
          {branchError ? (
            <p className="mt-4 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-700">
              {branchError}
            </p>
          ) : null}
        </div>
      </div>
    </ResponsiveShell>
  )
}
